import { createSlice } from '@reduxjs/toolkit';
import { IOrderCounter } from '../../../../dto';
import { setOrderCounter } from '../actions';
import { MN_ORDER_COUNTERS, TYPE_ELEMENT } from '../../../../common';

export interface OrderCounterState {
  data: IOrderCounter | null;
  loading: boolean;
  error: string | null;
}

const initialState: OrderCounterState = {
  data: null,
  loading: false,
  error: null,
};

export const orderCounterSlice = createSlice({
  name: `${MN_ORDER_COUNTERS}/${TYPE_ELEMENT}`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setOrderCounter, (state, { payload }) => {
      state.data = payload;
    });
  },
});
